import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";

const DivindingEstate = () => {
  return (
    <>
      <div className="container">
        <div className="grid grid-cols-2 mt-[30px] max-lg:grid-cols-1">
          <div>
            <p className="text-[26px] font-semibold">Divide your estate</p>
            <p className="my-1 text-slate-500">
              Your estate is made up of everything you own. It includes bank
              accounts, your home, stocks and shares, ISAs and any personal
              belongings.
            </p>
            <p className="my-1 text-slate-500">
              You can use your will to leave a percentage of what you have, a
              set amount of money, or a specific item.
            </p>
            <p className="my-1 text-slate-500">
              But if you own something jointly, like a house or a shared bank
              account, you can’t leave it in your will: it will automatically
              pass to the other owner.
            </p>
            <p className="font-bold text-[26px] my-5">Helpful tips</p>
            <div className="my-4">
              <div>
                <p className="flex mt-3 text-slate-500 items-center gap-5">
                  <FaCheck className="text-[#7a3db6]" /> Leaving 10% of your
                  estate to charity lowers your inheritance tax rate
                </p>
                <p className="flex mt-3 text-slate-500 items-center gap-5">
                  <FaCheck className="text-[#7a3db6]" /> Anything you leave to a
                  child will be held in trust for them until they turn 18
                </p>
                <p className="flex mt-3 text-slate-500 items-center gap-5">
                  <FaCheck className="text-[#7a3db6]" /> You can name 'back-up'
                  beneficiaries in case someone dies before you
                </p>
              </div>
            </div>
            <div className="mt-[20px]">
              <div className="py-5 border-b-2">
                <div className="border-black rounded-xl border-[1px] p-3">
                  <div className="flex gap-5">
                    <div className="w-[10%]">
                      <img src="/assets/images/write-icon.png" alt="write" />
                    </div>
                    <div className="w-[100%]">
                      <p className="text-[20px] my-3 font-bold">
                        Unlimited changes!
                      </p>
                      <p className="text-[18px] text-slate-500">
                        With WillsGuru, you can get unlimited updates to your will.
                        So if you change your mind about who should get what,
                        you can always log in later and make changes. We’ll even
                        check your will again for you. For now, it’s important
                        just to get a copy signed ASAP.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pt-5 flex justify-between items-center">
                <div className="flex  pb-5">
                  <Link to={"/dashboard"}>
                    <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                      <FaAngleLeft />
                      Back
                    </button>
                  </Link>
                </div>
                <div className="flex  pb-5">
                  <Link to={"/make-will-online/estate/beneficiaries"}>
                    <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-1">
                      Next <FaChevronRight />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="max-lg:hidden bg-no-repeat ">
              <div className="fixed top-[100px] w-[500px] right-[6%]">
                <img src="/assets/images/9.png" alt="mascot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DivindingEstate;
